document.addEventListener('DOMContentLoaded', function () {
  function updateNewsletterPlaceholder() {
    const emailInputWrappers = document.querySelectorAll('input[type="email"]'); // Sélectionne tous les éléments
    const newsletterLabelWrappers = document.querySelectorAll('.newsletter-form__field-wrapper');

    const urlParams = new URLSearchParams(window.location.search);
    const hash = window.location.hash;

    const isGoodHash = hash === '#newsletter' || hash === '#contact_form';
    
    // Vérifie si l'URL et le hash sont corrects pour la newsletter
    if ((urlParams.get('form_type') === 'customer' && isGoodHash) ||
        (urlParams.get('customer_posted') === 'true' && isGoodHash)) {
      
      newsletterLabelWrappers.forEach((wrapper) => {
        const label = wrapper.querySelector('.field__label');
        
        if (label) {
          label.textContent = 'THANKS FOR SUBSCRIBING'; // Mise à jour du texte
        }
      });
      
      emailInputWrappers.forEach((emailInput) => {
        emailInput.setAttribute('placeholder', 'THANKS FOR SUBSCRIBING'); // Mise à jour du placeholder
      });

      window.scrollTo(0, document.body.scrollHeight);
    }
  }

  // Exécuter immédiatement
  updateNewsletterPlaceholder();

  // Réessayer après un délai au cas où les éléments seraient ajoutés dynamiquement
  setTimeout(updateNewsletterPlaceholder, 1000);
});
